<template>
    <div class="drawerLayer" style="z-index: 999" v-show="visible">
<!--        <div class="mask" @click="close();"></div>-->
        <div class="topDrawer white_bg datumFilterDrawer fullSpace" style="overflow: auto">
            <div>
                <header class="header" style="padding: 11px 16px; line-height: 22px">
                    <div class="flexLayout">
                        <div style="width: 22px; ">
                            <i class="icon backIcon fl" @click="close()"></i>
                        </div>
                        <div class="flexItem alignCenter black fWeight600">{{title}}</div>
                        <div style="width: 24px; ">
<!--                            <i class="icon closeIcon"-->
<!--                               @click="close()"></i>-->
                        </div>
                    </div>
                </header>
                <div class="body generalPagePaddingH" style="padding-bottom: 34px;">

                    <div class="topCategorySelectArea">
                        <span class="topCategoryItem" :class="{ active : selectedFirstCategory == null}"
                              @click="selectFirstCategory(null)">
                            全部
                        </span>
                        <span class="topCategoryItem" :class="{ active : selectedFirstCategory == categoryItem}"
                              v-for="categoryItem in categoryList" :key="categoryItem.id"
                              @click="selectFirstCategory(categoryItem)">
                            {{categoryItem.title}}
                        </span>
                    </div>

                    <div class="subListSelectArea" style="margin-top: 16px; margin-bottom: 4px;"
                        v-show="selectedFirstCategory">
                        <van-row gutter="3.5">
                            <van-col span="6">
                                <span class="subListItem" :class="{ active : selectedSecondCategoryList.length < 1}"
                                      @click="selectedSecondCategoryList = []">
                                    全部
                                </span>
                            </van-col>
                            <van-col span="6" v-for="categoryItem in subListList" :key="categoryItem.id" >
                                <span class="subListItem" :class="{ active : selectedSecondCategoryExistItem(categoryItem)}"
                                      @click="selectSecondCategory(categoryItem)">
                                    {{categoryItem.title}}
                                </span>
                            </van-col>
                        </van-row>
                    </div>

                    <div v-for="typeItem in typeFilterList" :key="typeItem.id" style="margin-bottom: 4px;">

                        <div class="greyLine"></div>

                        <div class="filterTitle">{{typeItem.title}}</div>
                        <div class="filterOptionArea clearfix">
                            <van-row>
                                <van-col span="6">
                                    <div class="filterOptionItem" :class="{ active : !isHaveTypeOptions(typeItem.subList)}"
                                         @click="selectedTypeOptionRemoveList(typeItem.subList)">
                                        全部
                                    </div>
                                </van-col>
                                <van-col span="6" v-for="typeOptionItem in typeItem.subList" :key="typeOptionItem.id">
                                    <div class="filterOptionItem" :class="{active : isSelectTypeOption(typeOptionItem)}"
                                         @click="selectTypeOption(typeItem, typeOptionItem)">
                                        {{typeOptionItem.title}}
                                    </div>
                                </van-col>
                            </van-row>
                        </div>
                    </div>

                    <div style="height: 40px;">
                        <div class="operationArea">
                            <div class="generalPagePaddingH flexLayout"
                                 style="padding-top: 6px; padding-bottom: 6px;">
                                <div style="flex: 122;">
                                    <button class="button resetButton" @click="reset()">重置</button>
                                </div>
                                <div class="marginL8" style="flex: 209;">
                                    <button class="button okButton" @click="ok()">确定</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';

import Vue from 'vue';

// component
import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);

// api
import datumApi from '@api/datum';

// util
import consoleHelper from "@util/consoleHelper";
import arrayHelper from "@util/arrayHelper";

const config = {
    categoryList : [{
        title : '教育教学',
        id : 1,
        subList : [{
            title : '全部',
            id : '',
        }, {
            title : '教学理论',
            id : '101',
        }, {
            title : '教案大全',
            id : '102',
        }, {
            title : '公开课大全',
            id : '103',
        }, {
            title : '手工大全',
            id : '104',
        }, {
            title : '活动方案',
            id : '105',
        }, {
            title : '游戏运动',
            id : '106',
        }]
    }, {
        title : '班级管理',
        id : 2,
        subList : [{
            title : '全部',
            id : '',
        }, {
            title : '教学理论',
            id : '101',
        }, {
            title : '教案大全',
            id : '102',
        }, {
            title : '公开课大全',
            id : '103',
        }, {
            title : '手工大全',
            id : '104',
        }, {
            title : '活动方案',
            id : '105',
        }, {
            title : '游戏运动',
            id : '106',
        }]
    }, {
        title : '家长工作',
        id : 3,
        subList : [{
            title : '全部',
            id : '',
        }]
    }, {
        title : '园所管理',
        id : 4,
        subList : [{
            title : '全部',
            id : '',
        }]
    }]

};

export default {
    name: "datumFilterDrawer",
    extends : drawerPart,
    components : {
        // "van-row" : vanRow,
        // "van-col" : vanCol,
    },
    props : {
        title : {
            type : String,
            default : ''
        },
    },
    data() {
        return {

            categoryList : config.categoryList,
            subListList : [],
            selectedFirstCategory : null,
            selectedSecondCategoryList : [],

            typeFilterList : [],
            selectedTypeFilterList : [],
        }
    },
    methods : {
        loadTagList() {
            datumApi.getTagList((result) => {
                this.categoryList = result.data.transverseTagList;
                this.typeFilterList = result.data.lengthwaysTagList;

                // this.selectFirstCategory(this.categoryList[0]);
            });
        },
        selectFirstCategory(item) {
            this.selectedFirstCategory = item;

            // set new sub category
            if (this.selectedFirstCategory)
            {
                this.subListList = item.subList;
            }

            // clean second category
            this.selectedSecondCategoryList = [];
        },
        selectSecondCategory(item) {
            if (arrayHelper.existElement(item, this.selectedSecondCategoryList))
            {
                this.selectedSecondCategoryList = arrayHelper.removeElement(this.selectedSecondCategoryList, item);
            }
            else
            {
                this.selectedSecondCategoryList.push(item);
            }
        },
        selectedSecondCategoryExistItem(item) {
            return arrayHelper.existElement(item, this.selectedSecondCategoryList);
        },
        selectedSecondCategoryExistItems(list) {
            for (let i=0; i<list.length; i++)
            {
                if (arrayHelper.existElement(list[i], this.selectedSecondCategoryList))
                {
                    return true;
                }
            }
            return false;
        },
        selectedSecondCategoryRemoveItems(list) {
            this.selectedSecondCategoryList = arrayHelper.removeElements(this.selectedSecondCategoryList, list);
        },
        selectGrade(gradeOptionItem)
        {
            this.selectedGradeOption = gradeOptionItem;
        },
        selectSubject(subjectOptionItem)
        {
            this.selectedSubjectOption = subjectOptionItem;
        },
        selectFileType(fileTypeOptionItem)
        {
            this.selectedFileTypeOption = fileTypeOptionItem;
        },
        selectTypeOption(typeItem, typeOption)
        {
            let exist = false;

            if (arrayHelper.existElement(this.selectedTypeFilterList, typeOption))
            {
                exist = true;
            }

            this.selectedTypeFilterList = arrayHelper.removeElements(this.selectedTypeFilterList, typeItem.subList);

            if (!exist)
            {
                this.selectedTypeFilterList.push(typeOption);
            }
        },
        isSelectTypeOption(optionItem) {
            return arrayHelper.existElement(optionItem, this.selectedTypeFilterList)
        },
        isHaveTypeOptions(optionList = []) {
            for (let i=0; i<optionList.length; i++)
            {
                if (arrayHelper.existElement(optionList[i], this.selectedTypeFilterList))
                {
                    return true;
                }
            }
            return false;
        },
        selectedTypeOptionRemoveList(optionList) {
            this.selectedTypeFilterList = arrayHelper.removeElements(this.selectedTypeFilterList, optionList);
        },

        reset() {
            // this.selectFirstCategory(this.categoryList[0]);
            this.selectedFirstCategory = null;
            this.selectedSecondCategoryList = [];
            this.selectedTypeFilterList = [];
        },

        ok() {
            this.$emit('changeFilter', {
                firstCategory : this.selectedFirstCategory,
                secondCategoryList : this.selectedSecondCategoryList,
                typeList : this.selectedTypeFilterList
            });
            this.close();
        }
    },
    mounted() {
        this.loadTagList();
    }
}
</script>

<style lang="scss" scoped>

.header {
    .backIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAA6klEQVRYhe3YvQ3CMBCGYQ+QARgByd19dscQDEKJBJuEeYAREBmEPqHAJ5EfA0WQ76J7pfSPIttxzjnLspab974CUAM4AziU9nwsYS9E1ALoALQAtqVdkyXs9Q3Lz7G0bVQOS0QPAOvSvl5fsJvSvl5asZ14bIxxpQ3baMLeB8eWeKz8DcbLwLBzZ9h/lT4KjYrTwDnnQgg7FW+WmwIDkAvOLQnR6NymM/TcaUaP7hEq0aKPO1V3YS6hb6rQqv7nOO1oPRtxiWhZoypuCp3Wt7xhIDdEJ7DMcSvnva+I6ITXQHtf2mNZ1g89AeIXVhte2p9YAAAAAElFTkSuQmCC');
    }
    .closeIcon {
        width: 24px;
        height: 24px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}

.topCategorySelectArea {
    font-size: 14px;
    font-weight: bold;
    color: #333;

    .topCategoryItem {
        position: relative;
        //display: block;
        display: inline-block;
        padding: 15px 0 10px;
        line-height: 28px;
        text-align: center;
        margin-right: 16px;

        &:last-child {
            margin-right: 0;
        }

        &.active {
            color: hsla(36, 100%, 57%, 1);
            &:after {
                display: block;
                content: '';
                width: 19px;
                height: 6px;
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAMCAYAAAAOCs/+AAABd0lEQVQ4jc2UsWqUQRRGFww2gk2aYJNs5pv9Awt5gDS7kIAW4gtEkLxASCoblRgIVgpWNoKiZr7ZX7OVYCXJM4hFQCwECxutRMSEnBSKWc1mXddNcODCwL13zpnLMJXK/77I8SIO10hqnCj3qZqkuI31DYfEo+kzB8mkm1h8j7BL1u0TkXJxCevLAVtgXe0o0KffkmBtUVaLYxEq66ex1rB2D3Nju1PsbRcxsL5i3aGsjw1NqhWu9OBBjgsdxTqPtXNksbVD0mNSuDCQTFlUSZNLZL3rwYCsW4ebPTWD9aFn488phuck3aCly5RqUBYFG9VxNqrjJDUo1aAVFsm6T9JrrL0/nxuvH30zF+dwbPchN8x4g8NMf6Nv1ebIenXMQp+x1n75Hvp7F5VTuDaL9XKoQjl+xGGVJzr7V0JdJT0xgbWM9WJAofc43MOTs2w2R/5ZqKvkZnOEZ6qTNc+6VnC8i+MDrIzjwx/7Faxl1mtztKdGB+HsA2RBRFQuqS2FAAAAAElFTkSuQmCC');
                background-repeat: no-repeat;
                background-size: 100% 100%;

                position: absolute;
                bottom: 6px;
                left: 50%;
                margin-left: -9.5px;
            }
        }
    }
}

.subListSelectArea {
    .subListItem {
        display: block;
        height: 26px;
        line-height: 26px;

        background: #F2F3F8;
        border-radius: 4px;
        border: solid 1px transparent;

        text-align: center;
        font-size: 14px;
        color: #5B616C;

        margin-bottom: 12px;

        &.active {
            background: #FFF8E8;
            border-color: #FFA724;

            color: #FFA724;
        }
    }
}

.datumFilterDrawer {
    .filterTitle {
        color: hsla(0, 0%, 20%, 1);
        font-size: 100%;
        font-weight: bold;
        padding: 16px 0 16px;
    }
    .filterOptionArea {
        min-width: 341px;
    }
    .filterOptionItem {
        display: block;
        //width: 80px;
        text-align: center;
        height: 26px;
        line-height: 26px;
        background: #F2F3F8;
        box-sizing: border-box;
        border: solid 1px transparent;
        border-radius: 4px;
        margin-right: 6px;
        margin-bottom: 12px;
        //float: left;

        &:nth-child(4n+3) {
            margin-right: 0;
        }

        &.active {
            background: #FFF8E8;
            border: 1px solid #FFA724;

            color: #FFA724;
        }
    }

    .greyLine {
        height: 1px;
        line-height: 1px;
        background-color: #F6F6F6;
    }
}

.operationArea {
    position: fixed;
    z-index: 5;
    height: 52px;
    width: 100%;
    left: 0;
    bottom: 0;

    background-color: white;
    box-shadow: 0px -8px 8px rgba(77, 77, 77, 0.05);

    .button {
        display: block;
        width: 100%;
        height: 36px;
        line-height: 36px;
        border-radius: 20px;

        font-size: 16px;
        color: hsla(0, 0%, 20%, 1);
    }
    .resetButton {
        background: #F2F3F8;
    }
    .okButton {
        background: #FFA724;
        color: white;
    }
}
</style>

